<template>
  <div class="require-window">
    <div class="card">
      <div>
        Company:
        <company-select class="company-select" v-model="form.company_id" @change="changeCompany" :disabled="companyLocked"></company-select>&nbsp;
        <el-button @click="cache" v-if="!companyLocked">Lock</el-button>
        <el-button @click="clear" style="margin-left:2px;" v-if="companyLocked">Clear</el-button>
      </div>
      <hr/>
      <div style="padding-left:4px;font-weight:bold;background-color:#ddd;height:26px;line-height:26px;margin-bottom:6px;">Requirement Note</div>
      <div style="margin-top:6px;">
        <el-input v-model="form.qty" placeholder="-qty-" style="width:90px;"></el-input>
        @
        <el-select v-model="form.currency" style="width:80px;">
          <el-option label="USD" value="USD"></el-option>
          <el-option label="RMB" value="RMB"></el-option>
          <el-option label="HKD" value="HKD"></el-option>
        </el-select>
        &nbsp;
        <el-input v-model="form.price" placeholder="-target price-" style="width:120px;"></el-input>&nbsp;
        cysremarks
        <el-input v-model="form.remark" placeholder="内部参考" style="width:160px;"></el-input>&nbsp;
        valid period
        <el-select v-model="form.valid_period" style="width:60px;">
          <el-option label="1" value="1"></el-option>
          <el-option label="2" value="2"></el-option>
          <el-option label="3" value="3"></el-option>
          <el-option label="4" value="4"></el-option>
          <el-option label="5" value="5"></el-option>
          <el-option label="6" value="6"></el-option>
          <el-option label="7" value="7"></el-option>
          <el-option label="8" value="8"></el-option>
        </el-select>
        day(s)
      </div>
      <hr/>
      <div>
        for sales
        <el-select v-model="form.sales_id" style="width:120px;">
          <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
        <el-checkbox true-label="1" false-label="0" v-model="form.visibility" style="margin-left:20px;">visible</el-checkbox>
        <el-button @click="save" style="margin-left:20px;">Save</el-button>
        <el-button @click="saveAndExit">Save &amp; Exit</el-button>
        <el-button @click="reset">Reset</el-button>
        <el-button @click="exit">Exit</el-button>
      </div>
    </div>
    <div class="card">
      <div>
        Product No: {{ productId }} &nbsp;&nbsp;&nbsp;show
        <el-select v-model="pageSize" style="width:120px;" @change="fetchList">
          <el-option label="30 pcs" :value="30"></el-option>
          <el-option label="40 pcs" :value="40"></el-option>
          <el-option label="60 pcs" :value="60"></el-option>
          <el-option label="80 pcs" :value="80"></el-option>
          <el-option label="100 pcs" :value="100"></el-option>
          <el-option label="150 pcs" :value="150"></el-option>
          <el-option label="200 pcs" :value="200"></el-option>
          <el-option label="300 pcs" :value="300"></el-option>
        </el-select>
      </div>
      <div flex>
        <div style="border-right:1px solid #000;" flex-box="1">
          <table class="cystron-table require-table">
            <tr style="height:0;border:0">
              <th style="width:90px;"></th>
              <th style="width:75px;"></th>
              <th style="width:45px;"></th>
              <th style="width:60px;"></th>
              <th style="width:70px;"></th>
              <th></th>
            </tr>
            <tr>
              <th colspan="6">
                Quotation
              </th>
            </tr>
            <tr>
              <th>input time</th>
              <th>company</th>
              <th>qty</th>
              <th>price</th>
              <th>remarks</th>
              <th>sales</th>
            </tr>
            <tr v-for="(item, index) in quotationList" :key="'quotation' + index" :class="trClass(item, index)">
              <td>{{ item.oper_time | shortDateTime }}</td>
              <td :title="item.company_name">{{ item.company_name }}</td>
              <td style="text-align:right;">{{ item.display_c_qty }}</td>
              <td :title="item.display_c_price">{{ item.display_c_price }}</td>
              <td :title="item.c_remark">{{ item.c_remark }}</td>
              <td>
                <el-tooltip class="item" effect="dark" :content="item.sales_fullname + ',input by ' + item.oper_name" placement="bottom">
                  <span>{{ item.sales_name }}</span>
                </el-tooltip>
              </td>
            </tr>
          </table>
        </div>
        <div flex-box="1">
          <table class="cystron-table require-table">
            <tr style="height:0;border:0">
              <th style="width:20px;"></th>
              <th style="width:90px;"></th>
              <th style="width:70px;"></th>
              <th style="width:45px;"></th>
              <th style="width:60px;"></th>
              <th style="width:70px;"></th>
              <th></th>
            </tr>
            <tr>
              <th colspan="7">
                Requirement
              </th>
            </tr>
            <tr>
              <th>Del</th>
              <th>input time</th>
              <th>company</th>
              <th>qty</th>
              <th>price</th>
              <th>remarks</th>
              <th>sales</th>
            </tr>
            <tr v-for="(item, index) in list" :key="item.id" :class="trClass(item, index)">
              <td>
                <el-button type="danger" style="padding:0;" @click="del(item.id)">del</el-button>
              </td>
              <td>{{ item.oper_time | shortDateTime }}</td>
              <td :title="item.company_name">{{ item.company_name }}</td>
              <td :title="item.display_qty" style="text-align:right;">{{ item.display_qty }}</td>
              <td>{{ item.display_price }}</td>
              <td :title="item.remark">{{ item.is_del === '1' ? `deleting by ${item.del_name}` : item.remark }}</td>
              <td>
                <el-tooltip class="item" effect="dark" :content="item.sales_fullname + ',input by ' + item.oper_name" placement="bottom">
                  <span>{{ item.sales_name }}</span>
                </el-tooltip>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import CompanySelect from '@/components/CompanySelect'
export default {
  mixins: [ListFunc],
  props: {
    productId: String
  },
  components: {
    CompanySelect
  },
  data () {
    return {
      sqlcode: 'product_requirement_list',
      pageSize: 40,
      list: [],
      total: 0,
      loading: false,
      form: {
        company_id: localStorage.getItem('cystron-offer-company-id') ? parseInt(localStorage.getItem('cystron-offer-company-id')) : null,
        sales_id: localStorage.getItem('cystron-offer-sales-id') ? parseInt(localStorage.getItem('cystron-offer-sales-id')) : null,
        qty: '',
        currency: 'USD',
        price: '',
        valid_period: '3',
        remark: '',
        visibility: '1',
        product_id: this.productId
      },
      quotationList: [],
      companyLocked: !!localStorage.getItem('cystron-offer-company-id')
    }
  },
  computed: {
    salesList () {
      return this.$store.state.select.sales
    }
  },
  mounted () {
    this.$store.dispatch('fetchSelect', 'sales')
    this.fetchList()
    this.fetchQuotationList()
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$http.get('/dbapi/' + this.sqlcode, {
        params: {
          product_id: this.productId,
          start: 0,
          limit: this.pageSize
        }
      }).then(data => {
        this.loading = false
        this.list = data.list
        this.total = data.total
      }).catch(() => this.loading = false)
    },
    refresh () {
      this.fetchList()
    },
    fetchQuotationList () {
      this.$http.get('/dbapi/product_offer_list', {
        params: {
          product_id: this.productId,
          start: 0,
          limit: this.pageSize
        }
      }).then(data => {
        this.quotationList = data.list
      })
    },
    cache () {
      localStorage.setItem('cystron-offer-company-id', this.form.company_id)
      localStorage.setItem('cystron-offer-sales-id', this.form.sales_id)
      this.companyLocked = true
    },
    clear () {
      this.form.company_id = null
      localStorage.removeItem('cystron-offer-company-id')
      localStorage.removeItem('cystron-offer-sales-id')
      this.companyLocked = false
    },
    save () {
      if (!this.form.company_id) {
        this.$message({
          type: 'error',
          message: 'Please select a company'
        })
        return
      }
      this.$http.post('/dbapi/requirement_insert', this.form).then(data => {
        this.$message({
          type: 'success',
          message: 'Saved.'
        })
        this.refresh()
      })
    },
    saveAndExit () {
      if (!this.form.company_id) {
        this.$message({
          type: 'error',
          message: 'Please select a company'
        })
        return
      }
      this.$http.post('/dbapi/requirement_insert', this.form).then(data => {
        this.$message({
          type: 'success',
          message: 'Saved.'
        })
        this.$close()
      })
    },
    reset () {
      this.form = {
        company_id: null,
        sales_id: null,
        qty: '',
        currency: 'USD',
        price: '',
        valid_period: '3',
        lead_time: '7 days',
        remark: '',
        visibility: '1',
        product_id: this.productId
      }
    },
    exit () {
      this.$close()
    },
    del (id) {
      this.$confirm('Delete?', 'Tips', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/requirement_del', { id: id }).then(data => {
          this.$message({
            type: 'success',
            message: 'Deleted.'
          })
          this.refresh()
        })
      })
    },
    changeCompany (val) {
      this.form.sales_id = val.sales_id
    },
    trClass (item, index) {
      if (item.is_del === '1') {
        return 'row-red'
      }
      if (item.is_special === '1') {
        return 'row-bg-yellow'
      }
      if (index % 2 === 1) {
        return 'row-bg-gray'
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.require-window {
  .require-table {
    table-layout: fixed;
    td {
      word-break: keep-all;/* 不换行 */
      white-space: nowrap;/* 不换行 */
      overflow: hidden;/* 内容超出宽度时隐藏超出部分的内容 */
      text-overflow: ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
    }
  }
}
</style>
